// @flow
import React from "react"
import { compose, withHandlers, type HOC } from "recompose"
import withConnect from "hoc/withConnect"
import { openModal } from "data/modals/actions"
import ForgotPassword from "modals/ForgotPassword"
import ModalBody from "modals/_Body"
import ModalHeader from "modals/_Header"
import LoginForm from "./LoginForm"

const LoginModal = ({ close, openSignup, openForgotPassword, callback }) => (
  <ModalBody close={close}>
    <ModalHeader close={close} title="Welcome back" />
    <LoginForm close={close} openForgotPassword={openForgotPassword} callback={callback} />
  </ModalBody>
)

const mapDispatchToProps = {
  openModal,
}

type Outter = {|
  close: Function,
  callback?: Function,
|}

const enhancer: HOC<*, Outter> = compose(
  withConnect(() => ({}), mapDispatchToProps),
  withHandlers({
    openForgotPassword: props => () => {
      props.close()
      props.openModal(ForgotPassword, {})
    },
  }),
)

export default enhancer(LoginModal)



// WEBPACK FOOTER //
// ./src/modals/Login/index.js